import { createSlice } from "@reduxjs/toolkit";

interface ThemeState {
  lightMode: boolean;
}

const initialState: ThemeState = {
  lightMode: true
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleMode: (state) => {
      state.lightMode = !state.lightMode;

      if (state.lightMode) {
        document.documentElement.classList.remove("dark-theme");
      } else {
        document.documentElement.classList.add("dark-theme");
      }
    }
  }
});

export const { toggleMode } = themeSlice.actions;
